import { setLocaleHeader } from '@brightdrop/auth-client';
import {
  type BaseQueryFn,
  createApi,
  type FetchArgs,
  type FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

let baseUrl = '';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '',
  prepareHeaders: (headers) => {
    if (!headers.has('Accept')) {
      headers.set('Accept', 'application/json, text/plain, */*');
    }
    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }
    setLocaleHeader(headers);

    return headers;
  },
});

const publicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${baseUrl}/entitlement${urlEnd}`;
  const adjustedArgs =
    typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };
  return rawBaseQuery(adjustedArgs, api, extraOptions);
};

/**
 * Public (unauthenticated) entitlements API.
 *
 * Use this for endpoints that do not require authentication.
 * Endpoints are injected via separate files (e.g., quickpayApi.ts).
 *
 * No token refresh. No Authorization header.
 */
export const publicApi = createApi({
  reducerPath: 'publicApi',
  baseQuery: publicBaseQuery,
  endpoints: () => ({}),
});

export const configurePublicApi = ({ apiBaseUrl }: { apiBaseUrl: string }) => {
  baseUrl = apiBaseUrl;
};
